import { Caracteristica } from "./caracteristica";
import { TipoProducto, TipoProductoCategoria } from "./tipo-producto";

export interface ProductoEstado {
    IdEstado?: number | string,
    descripcion?: string
}

export class Producto {
    constructor(
        public IdProducto: number | string = '',
        public fechaAlta: string = '',
        public descripcion: string = '',
        public stock: number = 0,
        public observaciones: string = '',
        public web: boolean = false,
        public destacado: boolean = false,
        public importe?: number,
        public importeMostrar: boolean = false,
        public estado: ProductoEstado = <ProductoEstado>{},
        public tipo: TipoProducto = <TipoProducto>{},
        public caracteristicas: Caracteristica[] = <Caracteristica[]>[],
        public descripcionCustom: boolean = false,
        public especial: boolean = false,
        public ProductoCUT: string = '',
        public categoria: TipoProductoCategoria = <TipoProductoCategoria>{},
    ) { }
}